import { Button, type ButtonProps } from '@/ui-components/atoms/Button/Button';
import styles from './headerSplit.module.scss';
import { Text } from '@/ui-components/atoms/Text/Text';
import { HeaderProps } from './Header';
import { Grid } from '@/ui-components/atoms/Layout/Grid/Grid';
import cn from 'classnames';
import { CTAGroup } from '@/ui-components/molecules/CTAGroup/CTAGroup';

export const HeaderSplit = ({
    heading,
    headingTag,
    subhead,
    channelNumber,
    caption,
    links,
    ctaGroupAlignment = 'left',
    theme = 'center',
    inheritTextColor = false,
    subHeadAbove = false,
    className,
    headingAriaLabel,
    type,
    isInHorizontallyRenderedGroup = false,
}: HeaderProps): React.JSX.Element => {
    const isPromoBanner = type === 'promoBanner';
    const isHorizontalPromo = isPromoBanner && isInHorizontallyRenderedGroup && theme === 'text-left-buttons-right';

    const containerClasses = cn(styles[theme], className, {
        [styles.promoBannerHorizontal]: isHorizontalPromo,
    });

    const linkNodes: React.ReactElement<ButtonProps>[] = [];

    if (links && links.length > 0) {
        const mainLinks = links.filter((link) => (link as ButtonProps).variant !== 'tertiary');
        const hasTwoMain = mainLinks.length === 2;
        const isPromoBanner = type === 'promoBanner';

        for (let i = 0; i < 3; i += 1) {
            const link = links[i] as ButtonProps | undefined;
            if (!link) continue;

            const variant = link.variant;
            const fitting: ButtonProps['fitting'] = isPromoBanner
                ? 'fill-container'
                : variant === 'tertiary'
                  ? 'hug-contents'
                  : hasTwoMain
                    ? 'fill-container'
                    : 'hug-contents';

            linkNodes.push(<Button key={i} {...link} fitting={fitting} className={styles.button} />);
        }
    }

    return (
        <Grid className={containerClasses}>
            <div className={styles.headingContainer + ' heading'}>
                {subHeadAbove ? (
                    <>
                        {subhead && (
                            <Text
                                tag="div"
                                variant="text-xlarge"
                                className={`${inheritTextColor ? styles.subhead : styles.subheadDefault} ${styles.subHeadAbove} ${type === 'heroHeader' ? styles.subheadInHeroHeader : ''} `}
                            >
                                {channelNumber ? (
                                    <>
                                        CH {channelNumber}
                                        <br />
                                        {subhead}
                                    </>
                                ) : (
                                    subhead
                                )}
                            </Text>
                        )}
                        {heading && (
                            <Text
                                tag={headingTag || 'h2'}
                                className={cn(headingTag || 'h2', styles.heading)}
                                ariaLabel={headingAriaLabel}
                            >
                                {heading}
                            </Text>
                        )}
                    </>
                ) : (
                    <>
                        {heading && (
                            <Text
                                tag={headingTag || 'h2'}
                                className={cn(headingTag || 'h2', styles.heading)}
                                ariaLabel={headingAriaLabel}
                            >
                                {heading}
                            </Text>
                        )}
                        {subhead && (
                            <Text
                                tag="div"
                                variant="text-xlarge"
                                className={`${inheritTextColor ? styles.subhead : styles.subheadDefault} ${type === 'heroHeader' ? styles.subheadInHeroHeader : ''}`}
                            >
                                {channelNumber ? (
                                    <>
                                        CH {channelNumber}
                                        <br />
                                        {subhead}
                                    </>
                                ) : (
                                    subhead
                                )}
                            </Text>
                        )}
                    </>
                )}
            </div>

            {!!links?.length && (
                <div className={styles.buttonContainer}>
                    <CTAGroup
                        links={linkNodes}
                        caption={caption}
                        desktopAlign={ctaGroupAlignment}
                        mobileAlign="center"
                    />
                </div>
            )}
        </Grid>
    );
};
